import React from "react";
import { useIntl, defineMessages } from "react-intl";

const messages = defineMessages({
  minOrderAmountOk: {
    id: "modules.Cart.Minicart.MiniCartContent.MinicartMinOrderAmount.minOrderAmountOk",
    defaultMessage: "Minimum order amount reached",
  },
  minOrderAmountNotOk: {
    id: "modules.Cart.Minicart.MiniCartContent.MinicartMinOrderAmount.minOrderAmountNotOk",
    defaultMessage:
      "To reach the minimum order amount, you need to add {amount} €",
  },
});

const MinicartMinOrderAmount = ({ cart }) => {
  const intl = useIntl();
  let amountToReachMinOrderAmount =
    parseFloat(cart.minimum_order_amount) -
    cart.totals.subtotalExclTax.value.amount;
  amountToReachMinOrderAmount = parseFloat(
    amountToReachMinOrderAmount.toFixed(2)
  );

  if (
    cart.totals.subtotalExclTax.value.amount <
    parseFloat(cart.minimum_order_amount)
  ) {
    return (
      <div className="minicart-min-order-amount minicart-min-order-amount--ko">
        {intl.formatMessage(messages.minOrderAmountNotOk, {
          amount: amountToReachMinOrderAmount,
        })}
      </div>
    );
  }
  return (
    <div className="minicart-min-order-amount minicart-min-order-amount--ok">
      {intl.formatMessage(messages.minOrderAmountOk)}
    </div>
  );
};

export default MinicartMinOrderAmount;
